<template>
  <div class="about-page">
    <v-container fluid class="home px-0">
      <hero/>
    </v-container>
    <v-container fluid-md id="about">
      <v-layout row wrap grid-list-md>
        <v-flex
          class="mb-5 pt-2"
          text-md-left
          text-xs-left
          xs12
          md5
        >
          <h2 class="primary--text">Hi! We're <br> TD&nbsp;LAB. <br>—</h2>
          <p>
            We’re an innovation team within TD focused on experiences "for students, by students"
            that look at the unique financial challenges of post-secondary life.
          </p>
          <p>
            Located in the Communitech hub, in Kitchener-Waterloo, our talented team combines a mix of
            developers, designers, business analysts and co-op interns who help us build the concepts
            <span class="text-italic"> they'd </span> <span>like to use.</span>
          <p> But don’t just take our word for it.</p>
          <p>
            We're asking the post-secondary students of Waterloo region to help us test them out,
            so we are truly putting the student at the centre of the experience.
          </p>
        </v-flex>
        <v-flex
          class="mb-5 pt-2"
          text-md-justify
          text-xs-left
          xs12
          md6
          offset-xs0
          offset-md1
        >
          <ig-feed />
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid-md>
      <v-layout row wrap grid-list-md>
        <v-flex
          text-xs-center
          xs12
          class="my-5 primary--text"
        >
          <h2>More coming soon!</h2>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style lang="scss">
.about-page {
  background-color: white;
}

</style>

<script>
import hero from '@/components/hero.vue'
import igFeed from '@/components/igFeed.vue'

export default {
  components: {
    hero,
    igFeed
  },
  metaInfo: {
    title: 'TD Lab',
    titleTemplate: null,
    meta: [
      { vmid: 'description', name: 'description', content: 'home' }
    ]
  },
  data () {
    return {
    }
  },
  mounted () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', true)
      this.$store.dispatch('navSetDark', true)
      this.$store.dispatch('navSetNone', true)
    }
  },
  beforeDestroy () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', false)
      this.$store.dispatch('navSetNone', false)
    }
  }
}
</script>
